<script setup lang="ts">
import { useAuthStore } from "@/stores";
import AdminHomeView from "@/views/Admin/AdminHome.vue";
import CandidateHomeView from "@/views/Candidate/CandidateHome.vue";

const authStore = useAuthStore();
</script>

<template>
  <main>
    <AdminHomeView v-if="authStore.isAdmin" />
    <CandidateHomeView v-else-if="authStore.isCandidate" />
    <div v-else></div>
  </main>
</template>
